<template>
    <v-overlay :value="valueData" z-index="99999999">
        <spinner-cadu
            :line-fg-color="$vuetify.theme.themes.light.primary1"
            :size="100"
            :line-size="5"
            :speed="0.6"
            :font-size="30"
            :spacing="10"
            :text-fg-color="'white'"
            message="Carregando"
        />
    </v-overlay>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      valueData: this.value,
      hidden: false
    }
  },
  beforeDestroy () {
    if (document.documentElement.style.overflow !== 'hidden auto') {
      document.documentElement.style.overflow = 'hidden auto'
    }
  },
  watch: {
    value () {
      this.valueData = this.value
    },
    valueData () {
      let overflow = document.documentElement.style.overflow
      if (!this.valueData) {
        if (overflow !== 'hidden auto' && !this.hidden) {
          document.documentElement.style.overflow = 'hidden auto'
        }
        this.$emit('input', false)
      } else {
        if (overflow === 'hidden') {
          this.hidden = true
        } else {
          document.documentElement.style.overflow = 'hidden'
        }
      }
    }
  }
}
</script>
